import { Control, Controller, FieldValues, useForm } from "react-hook-form";
import { ErrorText } from "../common.style";
import styled from "styled-components";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

type Props = {
  name: string;
  control: Control<FieldValues, any>;
  label: string;
  defaultValue?: Date;
};

const DatePickerField = ({ name, control, label, defaultValue }: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState: { errors } }) => {
        const errorMessage = errors[name]?.message ?? null;
        let inputDefaultValue = new Date();
        if (defaultValue) {
          inputDefaultValue = defaultValue;
        }
        let inputDefaultValueS =
          inputDefaultValue.getFullYear() +
          "-" +
          (inputDefaultValue.getMonth() + 1 + "").padStart(2, "0") +
          "-" +
          (inputDefaultValue.getDate() + "").padStart(2, "0");

        return (
          <>
            {errorMessage && typeof errorMessage === "string" && (
              <ErrorText>{errorMessage}</ErrorText>
            )}
            <div>
              <div>{label}</div>
              <DivDate>
                <input
                  type="date"
                  defaultValue={inputDefaultValueS}
                  onChange={field.onChange}
                ></input>
              </DivDate>
            </div>
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label={label}
                onChange={(date) => {
                  field.onChange(date);
                }}
                // value={null }

                // onChange={field.onChange}
                // {...field}
                // defaultValue={new Date()}
              />
            </LocalizationProvider> */}
          </>
        );
      }}
    />
  );
};

const DivDate = styled.div`
  margin-top: 0.5rem;
`;

// const TextInputField = styled(TextField)`
//   &&& .MuiFormLabel-root {
//     color: currentColor;
//   }

//   &&& .MuiInputBase-root {
//     border: ${(props) => (props?.error ? "red" : "auto")};
//   }
// `;

export default DatePickerField;
